import { bondAnalyserGaEventsName } from "@helpers/ga-events-name-enum";

export const tabsContent = [
    {
        id: 1,
        label: 'Bond Market Growth Trend',
        image: '/images/bond-analyser/bond-market-growth-trends.svg',
        activeImage: '/images/bond-analyser/bond-market-growth-trends-active-tab.svg',
        content: {
            heading: `Indian Bond Market has grown <span class="h6-semibold xl:h3-bold text-basicWhite">~7.5x in the last decade</span>`,
            description: 'Over the past decade, the bond market has grown with in India has grown at a CAGR of ~25% with growth in the last 4 years at an even faster rate. Listed bond issuance in 2024 exceeded INR 9.5 lakh crore (US$ 110bn).',
            image: '/images/bond-analyser/homepage-category-1.svg',
            insights: ''
        },
        link: '/bond-analyser/categories/bond-market-trends',
        gaEventName: bondAnalyserGaEventsName.BA_CLICKED_EXPLORE_MARKETGROWTH_HOME
    },
    {
        id: 2,
        label: 'Bond Market Analysis',
        image: '/images/bond-analyser/issuance-insights.svg',
        activeImage: '/images/bond-analyser/issuance-insights-active-tab.svg',
        content: {
            heading: `NBFC Issuances have grown 9x in 5 Years, <br class='xl:hidden'/> Hitting ₹3.2 Lakh Crore in 2024`,
            description: 'Bond market remains heavily dominated by government, PSU and financial service issuances. The sharp increase in NBFC borrowings and the increasing share of Non PSU issuers accessing the capital market signals that the market is widening providing more choices to investors.',
            image: '/images/bond-analyser/homepage-category-3.svg',
            insights: ''
        },
        link: '/bond-analyser/categories/bond-market-analysis',
        gaEventName: bondAnalyserGaEventsName.BA_CLICKED_EXPLORE_MARKETANALYSIS_HOME
    },
    {
        id: 3,
        label: 'Credit & Yield Analysis',
        image: '/images/bond-analyser/trade-analytics.svg',
        activeImage: '/images/bond-analyser/trade-analytics-active-tab.svg',
        content: {
            heading: '5.5x growth in high yield investment grade bonds in last 3 years',
            description: 'With new borrowers coming to the market, there has been ~5.5x growth in issuances that are investment grade but rated BBB+ or below. From just a ~INR 3000cr borrowing in 2021, they have gone to ~INR16,500cr in 2024. Strong increase in new issuers across the rating spectrum signals the widening of the market providing good risk adjusted returns for investors.',
            image: '/images/bond-analyser/homepage-category-2.svg',
            insights: ''
        },
        link: '/bond-analyser/categories/credit-yield-analysis',
        gaEventName: bondAnalyserGaEventsName.BA_CLICKED_EXPLORE_CREDIT_YIELD_HOME
    },
]; 


export const categoryWithoutAuthContent = [
    {
        id: 1,
        label: 'Bond Market Growth Trends',
        image: '/images/bond-analyser/bond-market-growth-trends.svg',
        activeImage: '/images/bond-analyser/bond-market-growth-trends-active-tab.svg',
        content: {
            heading: 'Bond Market Growth Trends',
            description: 'Understand the growth of Indian bond market',
            image: '/images/bond-analyser/homepage-category-1.svg',
            insights: ''
        },
        link: '/bond-analyser/categories/bond-market-trends',
        gaEventName: bondAnalyserGaEventsName.BA_CLICKED_EXPLORE_MARKETGROWTH_LIST
    },
    {
        id: 2,
        label: 'Bond Market Analysis',
        image: '/images/bond-analyser/issuance-insights.svg',
        activeImage: '/images/bond-analyser/issuance-insights-active-tab.svg',
        content: {
            heading: 'Bond Market Analysis',
            image: '/images/bond-analyser/homepage-category-3.svg',
            description: 'Understand bond market from a perspective of who are the issuers and the modes they utilize ',
            insights: [
                {
                    title: 'Sector split of Non-PSU Issuances',
                    description: ''
                },
                {
                    title: 'Private placement vs Public offer',
                    description: ''
                }
            ]
        },
        link: '/bond-analyser/categories/bond-market-analysis',
        gaEventName: bondAnalyserGaEventsName.BA_CLICKED_EXPLORE_MARKETANALYSIS_LIST
    },
    {
        id: 3,
        label: 'Credit & Yield Analysis',
        image: '/images/bond-analyser/trade-analytics.svg',
        activeImage: '/images/bond-analyser/trade-analytics-active-tab.svg',
        content: {
            heading: 'Credit & Yield Analysis',
            image: '/images/bond-analyser/homepage-category-2.svg',
            description: 'A market driven understanding of credit, tenor and yields',
            insights: [
                {
                    title: 'Bond issuance by credit rating',
                    description: ''
                },
                {
                    title: 'Yield based on Tenor and Rating',
                    description: ''
                }
            ]
        },
        link: '/bond-analyser/categories/credit-yield-analysis',
        gaEventName: bondAnalyserGaEventsName.BA_CLICKED_EXPLORE_CREDIT_YIELD_LIST
    }
]; 


export const advanceToolsTabsContent = [
    {
        id: 4,
        label: 'Credit Spread Analysis',
        image: '/images/bond-analyser/bond-market-growth-trends.svg',
        activeImage: '/images/bond-analyser/bond-market-growth-trends-active-tab.svg',
        content: {
            heading: 'Credit Spread Analysis',
            description: 'Understand the nuances of risk premium and yield benchmarking',
            image: '/images/bond-analyser/homepage-category-4.svg',
            insights: [
                {
                    title: "Yield Comparison - Gsec vs other credit ratings",
                },
                {
                    title: "Yield Comparison - Gsec vs Issuers",
                }
            ]
        },
        link: '/bond-analyser/categories/credit-spread-analysis',
        gaEventName: bondAnalyserGaEventsName.BA_CLICKED_EXPLORE_CREDITSPREAD_LIST
    },
    {
        id: 5,
        label: 'Issuer History & Analysis',
        image: '/images/bond-analyser/trade-analytics.svg',
        activeImage: '/images/bond-analyser/trade-analytics-active-tab.svg',
        content: {
            heading: 'Issuer History & Analysis',
            description: 'Analysis of Issuers with their history in capital market, yield benchmarking and secondary market trades.',
            image: '/images/bond-analyser/homepage-category-5.svg',
            insights: [
                {
                    title: 'Year on Year number & size of issuance for an Issuer',
                },
                {
                    title: 'Secondary trade volume and yield',
                },
                {
                    title: 'Yield comparison with similar rated issuers',
                },
            ]
        },
        link: '/bond-analyser/categories/issuer-history-analysis',
        gaEventName: bondAnalyserGaEventsName.BA_CLICKED_EXPLORE_ISSUERHISTORY_LIST
    },
    {
        id: 6,
        label: 'Specific Bond Analysis',
        image: '/images/bond-analyser/issuance-insights.svg',
        activeImage: '/images/bond-analyser/issuance-insights-active-tab.svg',
        content: {
            heading: 'Specific Bond Analysis',
            description: 'Compare a bond against another and understand the market dynamics of any specific bond ',
            image: '/images/bond-analyser/homepage-category-6.svg',
            insights: [
                {
                    title: 'Trading volume and trading yield',
                },
                {
                    title: 'Comparison with a similar rated bond',
                }
            ]
        },
        link: '/bond-analyser/categories/specific-bond-analysis',
        gaEventName: bondAnalyserGaEventsName.BA_CLICKED_EXPLORE_BONDANALYSIS_LIST
    }
]; 